import { Input } from 'antd'
import { inject, observer } from 'mobx-react'
import React from 'react'
import { MagnifierOutlineIcon } from '../../components/AppIcon'

const ProposalAdvanceInputFilter = props => {
  const { proposalAdvanceStore } = props

  const onSearch = value => {
    proposalAdvanceStore.setQueryParams('filterPage', 0)
    proposalAdvanceStore.setQueryParams('filterKeyword', value)
  }

  return (
    <Input.Search
      allowClear
      onSearch={onSearch}
      maxLength={500}
      placeholder="Tìm kiếm theo tiêu đề"
      enterButton={
        <MagnifierOutlineIcon
          style={{ color: '#000', width: 16, height: 16 }}
        />
      }
      className="custom-search-input fixed-width"
    />
  )
}

ProposalAdvanceInputFilter.propTypes = {}

export default inject('proposalAdvanceStore')(
  observer(ProposalAdvanceInputFilter)
)
